export const environment = {
    production: false,
    apiKey: 'devKey',
    apiUrl : "https://soulmusic.onrender.com/api"
  };

